import React from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser } from "../services/auth";

/** Legacy wrapper. Page access is also enforced by package permissions in PermissionRoute. */
export default function AdminRoute({ children, requireGroup = false }) {
  const user = getCurrentUser();

  if (user && (!requireGroup || Number(user.user_group) === 99)) return <>{children}</>;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Navigate to="/login" replace />;
}
